function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m226.5625 395.023438v116.96875h60v-116.96875l-30-20zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m256.628906 221.996094c-8.273437 0-15 6.730468-15 15 0 8.269531 6.726563 15 15 15 8.269532 0 15-6.730469 15-15 0-8.269532-6.730468-15-15-15zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m386.105469 195.425781-114.542969-94.496093v-37.929688h23.617188c8.28125 0 15-6.71875 15-15 0-8.285156-6.71875-15-15-15h-23.617188v-18c0-8.285156-6.71875-15-15-15-8.285156 0-15 6.714844-15 15v18h-23.617188c-8.285156 0-15 6.714844-15 15 0 8.28125 6.714844 15 15 15h23.617188v37.929688l-114.542969 94.496093c-3.457031 2.851563-5.457031 7.09375-5.457031 11.570313v289.996094c0 8.285156 6.71875 15 15 15h60v-125c0-5.011719 2.507812-9.695313 6.679688-12.480469l45-30c5.039062-3.355469 11.601562-3.355469 16.640624 0l45 30c4.171876 2.785156 6.679688 7.46875 6.679688 12.480469v125h60c8.28125 0 15-6.714844 15-15v-289.996094c-.003906-4.476563-2.003906-8.71875-5.457031-11.570313zm-129.476563 86.570313c-24.8125 0-45-20.1875-45-45s20.1875-45 45-45 45 20.1875 45 45-20.1875 45-45 45zm0 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m.5 348.398438v148.601562c0 8.285156 6.714844 15 15 15h76l.066406-245.800781-85.613281 70.628906c-3.453125 2.847656-5.453125 7.09375-5.453125 11.570313zm0 0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m507.039062 336.828125-85.480468-70.519531-.003906 245.691406h75.9375c8.285156 0 15-6.71875 15-15v-148.601562c0-4.476563-2-8.722657-5.453126-11.570313zm0 0"
});

var SvgChurch = function SvgChurch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 511 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChurch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/church.362f8769.svg";
export { ForwardRef as ReactComponent };